import { Component, OnInit } from '@angular/core';
import { ViewController, NavController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';

@Component({
  selector: 'sts-job-near-me',
  templateUrl: 'jobs-near-me.component.html'
})
export class JobNearMeComponent implements OnInit {
  countries: any;
  states: any;  
  selectedState: any;
  selectedCountry: any;
  city: string = '';
  searchParams: any = [];
  private jobsNearMe: FormGroup;
  constructor (
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder
  ){
    this.jobsNearMe = this.formBuilder.group({
      'country': ['', null],
      'state': ['', null],
      'city': ['', null]
    });
    this.getCountries();
  }

  ngOnInit() {
  }

  getCountries() {
    this.authenticationService.getCountries().subscribe(
      (response) => {
        this.countries = response;
      }, (error) => {
      });
    }

  getStatesByCountry() {
    this.states = [];
    if (this.selectedCountry.hasProvince) {
      this.authenticationService.getStatesByCountry(this.selectedCountry.countryCd).subscribe(
        (response) => {
          this.states = response;
        }, (error) => {          
        });
      }
    }

  searchJobs() {
    const selCountry = this.selectedCountry ? this.selectedCountry.countryName : '';
    const selState = this.selectedState ? this.selectedState.provinceName : '';
    this.searchParams = new Array();
    this.searchParams.push({ name: 'Country', value: selCountry });
    this.searchParams.push({ name: 'State', value: selState });
    this.searchParams.push({ name: 'City', value: this.city });
    this.closeJobsNearMe(this.searchParams);
  }

  closeJobsNearMe(data) {
    this.viewCtrl.dismiss(data);
  }
    
  isValidForm() {
    return this.jobsNearMe.valid;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/jobs-near-me/jobs-near-me.component.ts